import { ResponsiveValue, Theme, TLengthStyledSystem } from 'styled-system'
import { r } from '../functions'

export default function ultraRemConvertor(
  value?: ResponsiveValue<string | number | symbol, Required<Theme<TLengthStyledSystem>>>,
) {
  if (value === 0) return '0'
  if (typeof value === 'string' && value.match(/[^0-9]/)) return {}

  return value
    ? typeof value === 'number' || typeof value === 'string'
      ? r(+value as number)
      : Object.fromEntries(Object.entries(value).map(([key, val]) => [key, r(val)]))
    : {}
}
